
"use client";

import React from "react";

const LabelNode = ({
  data
}: {
  data: any;
}) => {
  return <div style={{
    pointerEvents: 'none'
  }}>
      {data.label}
    </div>;
};

export default LabelNode;
